/**
 * @author alexdkhu
 * 不实现一个全量库了...只实现最简单的功能
 * 比对可以通过array，object或string来做
 */
// TODO 改成set或map来写
// funcs每项为{ key: array|obj|number|string, cal: [] }
import {
    compareFactory,
    compareType,
} from './compare';
const funcs: Array<any> = [];

/**
 * @param {array|obj|number|string} key 用于比较的key
 *  */
function findItemInFuncs(key) {
    const compare = compareFactory(key);
    // 首先找到funcs里类型相同的
    const fixed = funcs.filter(item => compareType(key, item.key));
    // 随后找到对应的item
    return fixed.find(item => compare(key, item.key));
}

export function on(key, cal) {
    let item = findItemInFuncs(key);
    if (!item) {
        item = {
            key,
            cal: [],
        };
        funcs.push(item);
    }

    if (!item.cal.includes(cal)) {
        item.cal.push(cal);
    }
}

export function trigger(key, ...rest) {
    const item = findItemInFuncs(key);
    if (!item) return;

    // eslint-disable-next-line
    item.cal.map(func => func.apply(null, rest));
}

export function remove(key, cal) {
    const item = findItemInFuncs(key);
    if (!item?.cal.includes(cal)) return;
    const index = item.cal.findIndex(item => item === cal);
    item.cal.splice(index, 1);
}
